/* eslint-disable-next-line */
export interface UiKitProps {}

export function UiKit(props: UiKitProps) {
    return (
        <div>
            <h1>Welcome to UiKit!</h1>
        </div>
    );
}

export default UiKit;
